// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__Y0Bhu","icon":"SortAdornment_icon__HVuQj","up":"SortAdornment_up__2-GQJ","down":"SortAdornment_down__hRgyO","active":"SortAdornment_active__1ScE0"};